export default __webpack_public_path__ + "static/media/phoneCredit.3307777e.png";